import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import React from "react";
import { useContacts } from "utilities/api/contactQuery";

interface Props {
  hasArtist: boolean
  attendees: server.dto.ContactSmallV2[]
  withDetailViewLink: boolean
}

const ReadonlyAttendees = (props: Props) => {
  const attendees = useContacts(props.attendees);

  if (!props.hasArtist || props.attendees.length === 0) {
    return <div className="s1_gray">{RESX.Contact.NoContactSelected}</div>;
  }

  return <div className="flex-column" style={{ gap: 10 }}>
    {attendees.map(contact => (
      <div key={contact.contactId} className="flex gap">
        <div>
          {props.withDetailViewLink && <ContactSidePanel
            trigger={<a>{contact.name.fullName}</a>}
            contactId={contact.contactId}
          />}
          {!props.withDetailViewLink && contact.name.fullName}
          {contact.position && <div className="text-sublabel">{contact.position}</div>}
        </div>
      </div>
    ))}
  </div>;
};

export default ReadonlyAttendees;